export default __webpack_public_path__ + "static/7-3c1e2081aa94a8ac8a154b74da7b885a.jpg";